import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  signal
} from '@angular/core';

/**
 * Boot splash: slow page turns → zoom until cream pages fill the viewport → fade out & unmount.
 */
@Component({
  selector: 'app-splash-screen',
  standalone: true,
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.css'
})
export class SplashScreenComponent implements OnChanges, OnDestroy {
  @Input() active = true;
  @Input() tagline = "India's Literary Home";
  @Input() quote = 'A room without books is like a body without a soul.';
  @Input() quoteAuthor = 'Marcus Tullius Cicero';
  @Output() readonly closed = new EventEmitter<void>();

  readonly exiting = signal(false);
  readonly zooming = signal(false);

  private exitTimer: ReturnType<typeof setTimeout> | null = null;
  /** Zoom until pages fill the screen */
  private readonly zoomMs = 720;
  /** Soft fade after the veil covers everything */
  private readonly fadeMs = 280;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['active']) return;
    if (this.active) {
      this.clearExitTimer();
      this.exiting.set(false);
      this.zooming.set(false);
      return;
    }
    this.beginExit();
  }

  ngOnDestroy(): void {
    this.clearExitTimer();
  }

  private beginExit(): void {
    if (this.exiting() || this.zooming()) return;
    this.zooming.set(true);
    this.clearExitTimer();
    this.exitTimer = setTimeout(() => {
      this.exiting.set(true);
      this.exitTimer = setTimeout(() => {
        this.closed.emit();
        this.exitTimer = null;
      }, this.fadeMs);
    }, this.zoomMs);
  }

  private clearExitTimer(): void {
    if (this.exitTimer !== null) {
      clearTimeout(this.exitTimer);
      this.exitTimer = null;
    }
  }
}
